<template>
  <div v-if="cartStore.cart">
    <div class="flex flex-row items-baseline justify-between">
      <UiText>{{ $t('cart.itemsSubtotal') }}</UiText>
      <UiText>
        {{ formatPrice(locale as Locale, cartStore.cart.subtotal.amount, cartStore.cart.subtotal.currency_code) }}
      </UiText>
    </div>
    <div
      v-if="cartStore.cart.original_price.amount !== cartStore.cart.subtotal.amount"
      class="flex flex-row items-baseline justify-between text-neutral-500"
    >
      <UiText size="xs">{{ $t('cart.originalPrice') }}</UiText>
      <UiText size="xs">
        {{
          formatPrice(
            locale as Locale,
            cartStore.cart.original_price.amount,
            cartStore.cart.original_price.currency_code,
          )
        }}
      </UiText>
    </div>
    <div
      v-if="cartStore.cart.total_discount"
      class="mb-3 flex flex-row items-baseline justify-between text-secondary-700"
    >
      <UiText size="xs">
        {{
          $t('cart.savings', {
            price: formatPrice(
              locale as Locale,
              cartStore.cart.total_discount.amount,
              cartStore.cart.total_discount.currency_code,
            ),
          })
        }}
      </UiText>
    </div>
    <div v-if="cartStore.cart.shipping_amount" class="flex flex-row items-baseline justify-between">
      <UiText>{{ $t('cart.delivery') }}</UiText>
      <UiText v-if="cartStore.cart.shipping_amount.amount > 0">
        {{
          formatPrice(
            locale as Locale,
            cartStore.cart.shipping_amount.amount,
            cartStore.cart.shipping_amount.currency_code,
          )
        }}
      </UiText>
      <UiText v-else class="uppercase">{{ $t('general.free') }}</UiText>
    </div>
    <UiDivider class="mt-3" />
    <CouponCode />
    <UiDivider />
    <div v-if="cartStore.cart.total_discount" class="mt-3 rounded-md bg-secondary-100 p-1 text-center">
      <UiText size="sm" class="text-secondary-800">
        {{
          $t('cart.savingBanner', {
            amount: formatPrice(
              locale as Locale,
              cartStore.cart.total_discount.amount,
              cartStore.cart.total_discount.currency_code,
            ),
          })
        }}
      </UiText>
    </div>
    <div class="my-4 flex flex-row justify-between">
      <UiHeading type="h2">{{ $t('cart.totalPrice') }}</UiHeading>
      <UiHeading type="h2">
        {{ formatPrice(locale as Locale, cartStore.cart.total_price.amount, cartStore.cart.total_price.currency_code) }}
      </UiHeading>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '~/stores/cart/cartStore';

const cartStore = useCartStore();

const { locale } = useI18n();
</script>
